import { breakpoints } from "./eroadTheme/breakpoints";
import { colors } from "./eroadTheme/colors";
import { inputSizes } from "./eroadTheme/inputSizes";
import { shape } from "./eroadTheme/shape";
import { spacing } from "./eroadTheme/spacing";
import { typography } from "./eroadTheme/typography";
import { zIndex } from "./eroadTheme/zIndex";

/**
 * EROAD theme:
 * @reference https://material-ui.com/customization/default-theme/
 */
const eroadTheme = {
  breakpoints,
  colors,
  inputSizes,
  shape,
  spacing,
  typography,
  zIndex,
};

type EroadTheme = typeof eroadTheme;

export { eroadTheme };
export type { EroadTheme };
